import { Divider } from "@mui/material";

const FieldOptionsDivider = () => {
  return <Divider style={{ marginTop: 0, marginBottom: 0 }} />;
};

export default FieldOptionsDivider;
